import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import e from "../../core/Error.js";
import t from "../../core/Logger.js";
import { throwIfNotAbortError as r } from "../../core/promiseUtils.js";
import { zoomToFeature as i, zoomToClusteredFeatures as o, browseClusteredFeatures as n, removeSelectedFeature as a } from "./actions.js";

var s = "esri.widgets.Popup.PopupViewModel",
    c = t.getLogger(s),
    u = function u(t) {
  var s = t.event,
      c = t.view,
      u = s.action,
      d = c && c.popup;
  if (!u) return Promise.reject(new e("trigger-action:missing-arguments", "Event has no action"));
  if (!d) return Promise.reject(new e("trigger-action:missing-arguments", "view.popup is missing"));
  var l = u.disabled,
      v = u.id;
  if (!v) return Promise.reject(new e("trigger-action:invalid-action", "action.id is missing"));
  if (l) return Promise.reject(new e("trigger-action:invalid-action", "Action is disabled"));
  if (v === i.id) return g(d.viewModel).catch(r);
  if (v === o.id) return w(d.viewModel);
  if (v === n.id) return d.featureMenuOpen = !d.featureMenuOpen, d.viewModel.browseClusterEnabled = !d.viewModel.browseClusterEnabled, Promise.resolve();

  if (d.viewModel.browseClusterEnabled = !1, v === a.id) {
    d.close();
    var _t = d.selectedFeature;
    if (!_t) return Promise.reject(new e("trigger-action:".concat(a.id), "selectedFeature is required", {
      selectedFeature: _t
    }));
    var _r = _t.sourceLayer;
    return _r ? _r.remove(_t) : c.graphics.remove(_t), Promise.resolve();
  }

  return Promise.resolve();
};

function d(e) {
  var t = e.selectedFeature,
      r = e.location,
      i = e.view;
  if (!i) return null;
  if ("3d" === i.type) return t || r;
  return e.get("selectedFeature.geometry") || r;
}

function l(t, r) {
  if ("3d" !== (null == r ? void 0 : r.type) || !t || "esri.Graphic" !== t.declaredClass) return !0;
  var i = r.getViewForGraphic(t);

  if (i && "whenGraphicBounds" in i) {
    var _r2 = !1;

    return i.whenGraphicBounds(t, {
      useViewElevation: !0
    }).then(function (e) {
      _r2 = !e || !e.boundingBox || e.boundingBox[0] === e.boundingBox[3] && e.boundingBox[1] === e.boundingBox[4] && e.boundingBox[2] === e.boundingBox[5];
    }).catch(function () {
      var r = new e("zoom-to:invalid-graphic", "Could not zoom to the location of the graphic.", {
        graphic: t
      });
      c.error(r);
    }), _r2;
  }

  return !0;
}

function g(_x) {
  return _g.apply(this, arguments);
}

function _g() {
  _g = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
    var r, o, n, a, s, _t2, u, g, w;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            r = t.location, o = t.selectedFeature, n = t.view, a = t.zoomFactor, s = d(t);

            if (s) {
              _context.next = 4;
              break;
            }

            _t2 = new e("zoom-to:invalid-target-or-view", "Cannot zoom to location without a target and view.", {
              target: s,
              view: n
            });
            return _context.abrupt("return", (c.error(_t2), Promise.reject(_t2)));

          case 4:
            u = n.scale / a, g = t.get("selectedFeature.geometry") || r, w = g && "point" === g.type && l(o, n);
            i.active = !0, i.disabled = !0;
            _context.prev = 6;
            _context.next = 9;
            return t.view.goTo({
              target: s,
              scale: w ? u : void 0
            });

          case 9:
            _context.prev = 9;
            i.active = !1, i.disabled = !1, t.zoomToLocation = null, w && (t.location = g);
            return _context.finish(9);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6,, 9, 12]]);
  }));
  return _g.apply(this, arguments);
}

function w(_x2) {
  return _w.apply(this, arguments);
}

function _w() {
  _w = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t) {
    var r, i, _t3, _t4, n, a, s, _yield$a$queryExtent, u;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            r = t.selectedFeature, i = t.view;

            if (!("2d" !== (null == i ? void 0 : i.type))) {
              _context2.next = 4;
              break;
            }

            _t3 = new e("zoomToCluster:invalid-view", "View must be 2d MapView.", {
              view: i
            });
            throw c.error(_t3), _t3;

          case 4:
            if (r.isAggregate) {
              _context2.next = 7;
              break;
            }

            _t4 = new e("zoomToCluster:invalid-selectedFeature", "Selected feature must represent an aggregate/cluster graphic.", {
              selectedFeature: r
            });
            throw c.error(_t4), _t4;

          case 7:
            n = r.sourceLayer;
            _context2.next = 10;
            return i.whenLayerView(n);

          case 10:
            a = _context2.sent;
            s = a.createQuery();
            s.aggregateIds = [r.getObjectId()], o.active = !0, o.disabled = !0;
            _context2.next = 15;
            return a.queryExtent(s);

          case 15:
            _yield$a$queryExtent = _context2.sent;
            u = _yield$a$queryExtent.extent;
            _context2.next = 19;
            return i.goTo({
              target: u
            });

          case 19:
            o.active = !1;
            o.disabled = !1;

          case 21:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _w.apply(this, arguments);
}

function v(_x3) {
  return _v.apply(this, arguments);
}

function _v() {
  _v = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t) {
    var r, i, _t5, _t6, o, n, a, _yield$n$queryExtent, s;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            r = t.selectedFeature, i = t.view;

            if (!("2d" !== (null == i ? void 0 : i.type))) {
              _context3.next = 4;
              break;
            }

            _t5 = new e("displayClusterExtent:invalid-view", "View must be 2d MapView.", {
              view: i
            });
            throw c.error(_t5), _t5;

          case 4:
            if (r.isAggregate) {
              _context3.next = 7;
              break;
            }

            _t6 = new e("zoomToCluster:invalid-selectedFeature", "Selected feature must represent an aggregate/cluster graphic.", {
              selectedFeature: r
            });
            throw c.error(_t6), _t6;

          case 7:
            o = r.sourceLayer;
            _context3.next = 10;
            return i.whenLayerView(o);

          case 10:
            n = _context3.sent;
            a = n.createQuery();
            a.aggregateIds = [r.getObjectId()];
            _context3.next = 15;
            return n.queryExtent(a);

          case 15:
            _yield$n$queryExtent = _context3.sent;
            s = _yield$n$queryExtent.extent;
            t.selectedClusterBoundaryFeature.geometry = s, i.graphics.add(t.selectedClusterBoundaryFeature);

          case 18:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _v.apply(this, arguments);
}

function p(_x4) {
  return _p.apply(this, arguments);
}

function _p() {
  _p = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(t) {
    var r, i, _t7, _t8, o, a, s, _yield$a$queryFeature, u;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            r = t.selectedFeature, i = t.view;

            if (!("2d" !== (null == i ? void 0 : i.type))) {
              _context4.next = 4;
              break;
            }

            _t7 = new e("browseAggregateFeatures:invalid-view", "View must be 2d MapView.", {
              view: i
            });
            throw c.error(_t7), _t7;

          case 4:
            if (r.isAggregate) {
              _context4.next = 7;
              break;
            }

            _t8 = new e("browseAggregateFeatures:invalid-selectedFeature", "Selected feature must represent an aggregate/cluster graphic.", {
              selectedFeature: r
            });
            throw c.error(_t8), _t8;

          case 7:
            o = r.sourceLayer;
            _context4.next = 10;
            return i.whenLayerView(o);

          case 10:
            a = _context4.sent;
            s = a.createQuery();
            s.aggregateIds = [r.getObjectId()], n.active = !0, n.disabled = !0;
            _context4.next = 15;
            return a.queryFeatures(s);

          case 15:
            _yield$a$queryFeature = _context4.sent;
            u = _yield$a$queryFeature.features;
            n.active = !1, n.disabled = !1, i.popup.open({
              features: [r].concat(u),
              featureMenuOpen: !0
            });

          case 18:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _p.apply(this, arguments);
}

function f(e) {
  e.features = e.features.filter(function (e) {
    return e.isAggregate;
  });
}

export { p as browseAggregateFeatures, v as displayClusterExtent, d as getSelectedTarget, l as isZoomScreenSize, f as removeClusteredFeaturesForBrowsing, u as triggerAction, w as zoomToClusterExtent, g as zoomToLocation };